export default __webpack_public_path__ + "images/d127970a4a851640393d5f027c9772ae-reggae.jpg";